import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import MaterialTable from 'material-table';

// reactstrap components
import {
    Card,
    CardBody,
    Row,
    Col,
    Button,
    Container
} from "reactstrap";
import ProgressBar from "../../../components/ProgressBar/StepperProgress.jsx";

// style
import { table_translate } from "../../../constants/MaterialTable.js";

// services
import { showMessage, showQuestion } from "../../../services/message.js";
import { api_GET, api_POST } from "../../../services/api_service.js";

// views
import Veiculos from "../../Shared/Transportador/Veiculos";

//Context
import { useAuth } from '../../../context/auth.js';

export default function TransportadorRequerimentoAlteracao({ history }) {
    const { session, setLoading, setupSistema } = useAuth();
    const location = useLocation();
    const [requerimento, set_requerimento] = React.useState(null);

    const [veiculosAlteracao, setVeiculosAlteracao] = React.useState([]);
    const [protocolo, set_protocolo] = React.useState(null);

    const steps = ['Seleção do Veículo', 'Alteração'];
    const [step, set_step] = React.useState(0);

    const handleProximoStep = (_requerimento) => {
        if (veiculosAlteracao.length > 1 && requerimento?.setupSolicitacaoAcao?.setupSolicitacao?.categoria?.sigla == "RGG" && requerimento?.setupSolicitacaoAcao?.acao == "Alteração") {
            showMessage("Aviso", "Você deve selecionar um veículo que deseja alterar!", 'error', null);
            return;
        }

        if (step == 0) {
            if (veiculosAlteracao.length == 0) {
                showMessage("Aviso", "Você deve selecionar o(s) veículo(s) que deseja alterar!", 'error', null);
                return;
            }
            else {
                setLoading(true);
                var vRequerimentoTransportadorVeiculo_Id = 0;
                let RequerimentoTransportadorVeiculo = new Array();

                for (let veiculo of veiculosAlteracao) {
                    vRequerimentoTransportadorVeiculo_Id = 0;
                    if (requerimento.requerimentoTransportadorVeiculo.length > 0) {
                        var retVeiculoPorPlaca = requerimento.requerimentoTransportadorVeiculo.find(x => x.placaAntiga === veiculo.placa);
                        if (!!retVeiculoPorPlaca) {
                            vRequerimentoTransportadorVeiculo_Id = retVeiculoPorPlaca.requerimentoTransportadorVeiculo_Id;
                        }
                    }

                    let requerimentoTransportadorVeiculoModalidade = [];
                    veiculo.protocoloTransportadorVeiculoModalidades.map(m => {
                        requerimentoTransportadorVeiculoModalidade.push({
                            requerimentoTransportadorVeiculoModalidade_Id: 0,
                            requerimentoTransportadorVeiculo_Id: vRequerimentoTransportadorVeiculo_Id,
                            modalidade: m.modalidade
                        });
                    })

                    let item = {
                        requerimentoTransportadorVeiculo_Id: vRequerimentoTransportadorVeiculo_Id,
                        requerimento_Id: requerimento.requerimento_Id,
                        placa: veiculo.placa,
                        placaAntiga: veiculo.placa,
                        marca: veiculo.marca == null ? "" : veiculo.marca,
                        tipo: veiculo.tipo == null ? "" : veiculo.tipo,
                        capacidadeCarga: veiculo.capacidadeCarga == null ? "" : veiculo.capacidadeCarga,
                        cor: veiculo.cor == null ? "" : veiculo.cor,
                        tara: veiculo.tara == null ? "" : veiculo.tara,
                        anoFabricacao: veiculo.anoFabricacao == null ? "" : veiculo.anoFabricacao,
                        anoFabricacaoEquipamento: veiculo.anoFabricacaoEquipamento == null ? "" : veiculo.anoFabricacaoEquipamento,
                        numeroRenavam: veiculo.numeroRenavam == null ? "" : veiculo.numeroRenavam,
                        proprietarioOuLocado: veiculo.proprietarioOuLocado == null ? "" : veiculo.proprietarioOuLocado,
                        arquivoRenavam: veiculo.arquivoRenavam,
                        arquivoInspecaoInmetro: veiculo.arquivoInspecaoInmetro,
                        arquivoComprovanteTara: veiculo.arquivoComprovanteTara,
                        status: veiculo.status,
                        volume: veiculo.volume,
                        requerimentoTransportadorVeiculoModalidade: requerimentoTransportadorVeiculoModalidade
                    };

                    RequerimentoTransportadorVeiculo.push(item);
                };

                if (!!RequerimentoTransportadorVeiculo) {
                    // Excluir veículos antes de adicionar os novos selecionados                    
                    api_POST('requerimentoTransportador/PostRemoverVeiculosRequerimento/' + requerimento.requerimento_Id)
                        .then(result => {
                            let _requerimento = requerimento;
                            _requerimento.requerimentoTransportadorVeiculo = new Array();
                            _requerimento.requerimentoTransportadorVeiculo = RequerimentoTransportadorVeiculo;
                            set_requerimento(_requerimento);
                            set_step(step + 1);
                        })
                        .catch(err => showMessage("Aviso", err.message, 'error', null))
                        .finally(() => setLoading(false));
                };
            }
        }
        else {
            set_requerimento(_requerimento);
            set_step(step + 1);
        }
    }
    const handleStepAnterior = (_requerimento) => {
        set_requerimento(_requerimento)
        set_step(step - 1);
    }

    const loadRequerimento = () => {
        if (location.state.requerimento == null) {
            setLoading(true);
            let json_submit = {
                protocolo_Id: location.state.protocolo.protocolo_Id,
                requerimento_Id: 0,
                nomeSolicitante: location.state.protocolo.nomeSolicitante,
                email: location.state.protocolo.email,
                cpf_Cnpj: location.state.protocolo.cpf_Cnpj,
                setupSolicitacaoAcao_Id: location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id,
            }

            api_POST('requerimento/PostRequerimento ', json_submit)
                .then(result => {
                    set_requerimento(result.data);
                    set_step(0);
                    loadProtocolo(location.state.protocolo.protocolo_Id);
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
        else {
            api_GET('requerimento/' + location.state.requerimento.requerimento_Id)
                .then(result => {
                    set_requerimento(result.data);
                    set_step(0);
                    loadProtocolo(location.state.protocolo.protocolo_Id);
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }

    const loadProtocolo = (protocolo_Id) => {
        api_GET('ProtocoloTransportador/' + protocolo_Id)
            .then(result => set_protocolo(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleFinalizarRequerimento = () => {
        var TodosAlteracao = true;

        if (!!requerimento.requerimentoTransportadorVeiculo) {
            for (var validaAlteracao of requerimento.requerimentoTransportadorVeiculo) {
                if ((!!validaAlteracao.Alteracao) && (TodosAlteracao)) {
                    TodosAlteracao = true;
                }
                else {
                    TodosAlteracao = false;
                }
            }
        }

        if (TodosAlteracao == false) {
            showQuestion("Aviso", "Existem veículos que ainda não foram alterados. Deseja criar o requerimento mesmo assim? Com a confirmação, os veículos pendentes serão ignorados", "question", function (retorno) {
                if (retorno) {
                    finalizaSolicitacaoRequerimento();
                }
            });
        }
        else {
            finalizaSolicitacaoRequerimento();
        }

    }

    const finalizaSolicitacaoRequerimento = () => {
        api_POST('requerimento/PostFinalizarSolicitacaoRequerimento', requerimento)
            .then(result => {
                showMessage("Aviso", "Solicitação enviada com sucesso. Acompanhe o andamento através do seu cadastro! ", 'success', function () {
                    history.push("/auth/meucadastro");
                });
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadRequerimento();
    }, []);

    return (
        <>
            {requerimento != null && (requerimento.status == "Em Andamento" || requerimento.status == "Divergente") &&
                <div className="content">
                    <Container className="text-center">
                        <ProgressBar stepValue={step} steps={steps} />
                    </Container>
                    {requerimento.status == "Divergente" && requerimento.requerimentoAnaliseGestor.length > 0 &&
                        <Card className="card-stats">
                            <CardBody>
                                <h5 className="text-danger">Seu requerimento foi rejeitado por {setupSistema?.identificacao}. Verifique as informações abaixo e corrija os dados necessários.</h5>
                                <p>{requerimento.requerimentoAnaliseGestor.sort(function (a, b) { return new Date(b.dataAnalise) - new Date(a.dataAnalise); })[0].observacao}</p>
                            </CardBody>
                        </Card>
                    }
                    {step == 0 && protocolo != null &&
                        <Card className="card-stats">
                            <CardBody>
                                <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                                    <h2 className="titulo-solicitacao">Lista de Veículos</h2>
                                    <div className="formPrincipal">
                                        <Row>
                                            <Col md="12">
                                                <MaterialTable style={{ minHeight: "auto" }}
                                                    title=""
                                                    columns={[
                                                        { title: 'Placa', field: 'placa' },
                                                        { title: 'Marca', field: 'marca' },
                                                        { title: 'Ano', field: 'anoFabricacao' },
                                                        { title: 'Tipo', field: 'tipo' },
                                                        { title: 'Tara', field: 'tara' },
                                                        { title: 'Renavam', field: 'numeroRenavam' },
                                                        { title: 'Status', field: 'status' },
                                                        { title: 'Volume', field: 'volume' }
                                                    ]}
                                                    data={protocolo.protocoloTransportador[0].protocoloTransportadorVeiculo}
                                                    isLoading={false}
                                                    options={{
                                                        selection: true
                                                    }}
                                                    onSelectionChange={(rows) => {
                                                        setVeiculosAlteracao(rows)
                                                    }}
                                                    localization={table_translate}
                                                />
                                            </Col>
                                            <Col lg="6" className="text-left">
                                            </Col>
                                            <Col lg="6" className="text-right">
                                                {handleProximoStep != null &&
                                                    <Button
                                                        color="success"
                                                        onClick={handleProximoStep}
                                                        className="btn-mobile"
                                                        type="button">Próxima Etapa  <i className="fas fa-chevron-right"></i>
                                                    </Button>
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>
                            </CardBody>
                        </Card>
                    }
                    {
                        step == 1 &&
                        <Veiculos
                            item={requerimento}
                            totalVeiculos={location.state.protocolo.protocoloTransportador[0].protocoloTransportadorVeiculo.length}
                            tipoCadastro="Requerimento"
                            handleProximoStep={handleFinalizarRequerimento}
                            handleStepAnterior={handleStepAnterior}>
                        </Veiculos>
                    }
                </div>
            }
            {requerimento != null && (requerimento.status != "Em Andamento" && requerimento.status != "Divergente") &&
                <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                    <div className="formPrincipal">
                        <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, .5)", paddingBottom: "10px", paddingTop: "10px" }}>
                            <Col md="12">
                                <span className={`${session && session.tipoAcesso == "AreaRestrita" ? "text-white" : "text-black"}`}>Este requerimento já foi finalizado. Para visualizar e acompanhar as informações do requerimento, acesse o menu "Meu Cadastro".</span>
                            </Col>
                        </Row>
                    </div>
                </Container>
            }
        </>
    );
}